export const headerData = {
  tableName: 'API logs',
  hasPaging: true,
  fields: [
    {
      fieldName: 'type',
      headerName: 'Method',
    },
    {
      fieldName: 'endpoint',
      headerName: 'Endpoint',
    },
    {
      fieldName: 'status',
      headerName: 'Status',
    },
    {
      fieldName: 'dateStarted',
      headerName: 'Timestamp',
      isDatetime: true,
    },
    {
      fieldName: 'durration',
      headerName: 'Duration',
      isDuration: true,
    },
    {
      fieldName: 'isTestConnection',
      headerName: 'Connection Type',
      isConnectionType: true,
    },
  ],
};
